import React from "react";
import StyleSheet from "../commonComponents/StyleSheet";
import { logo } from "../assets/icons";
import config from "../config.json";
import useGlobalContext from "../Context/useGlobalContext";
import { Typography } from "@material-ui/core";

const Header = () => {
  const { currentTime } = useGlobalContext();
  return (
    <div style={styles.container}>
      <img src={logo} />
      <div style={styles.airportContainer}>
        <Typography style={styles.airportNameText}>
          {config.airportName}
        </Typography>
        <Typography style={styles.descriptionText}>
          {config.description}
        </Typography>
      </div>
      <Typography style={styles.timeText}>{currentTime}</Typography>
    </div>
  );
};

const styles = StyleSheet.create({
  container: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    width: "100vw",
    height: "55px",
    backgroundColor: config.backgroundColor,
    zIndex: 10,
    display: "flex",
    justifyContent: "space-between",
  },
  airportContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    height: "55px",
    width: '50vw',
  },
  airportNameText: {
    color: "#ffffff",
    fontWeight: "bold",
    fontSize: "20px",
    opacity: 0.8,
  },
  descriptionText: {
    color: "#ffffff",
    fontSize: "15px",
    opacity: 0.8,
    marginTop: "10px",
  },
  timeText: {
    color: "#ffffff",
    marginTop: "20px",
    opacity: 0.8,
    width: '15vw',
    textAlign: 'center'
  },
});

export default Header;
